/**
 * @generated SignedSource<<7ea3639a1f7cd5381b09d41135ec4171>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type orderLearnElement_OrderLearnElementFragment$data = {
  readonly answeringTypeText: string | null;
  readonly id: string;
  readonly orderItems: ReadonlyArray<{
    readonly id: string;
    readonly text: string;
  }>;
  readonly title: string;
  readonly " $fragmentType": "orderLearnElement_OrderLearnElementFragment";
};
export type orderLearnElement_OrderLearnElementFragment$key = {
  readonly " $data"?: orderLearnElement_OrderLearnElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"orderLearnElement_OrderLearnElementFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "orderLearnElement_OrderLearnElementFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answeringTypeText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderItem",
      "kind": "LinkedField",
      "name": "orderItems",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrderLearnElement",
  "abstractKey": null
};
})();

(node as any).hash = "74c4b9a1ceb22369298da3460eee1b88";

export default node;
